import { RootStore, withInjectedRootStore } from 'providers';
import { CreditSubtitle } from './CreditSubtitle';
import { Trans } from 'react-i18next';
import * as React from 'react';

const SecondUpgradeSubtitleComp: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
}) => {
  const { isSecondUpgrade } = rootStore.appStore;
  const { availableCredit } = rootStore.appStore.appContext;
  const shouldShowCreditSubtitle = () =>
    isSecondUpgrade && availableCredit >= 10;

  return shouldShowCreditSubtitle() ? (
    <CreditSubtitle />
  ) : (
    <Trans i18nKey='app.second_upgrade_text'>
      Get credit for your current Yearly Plan when you switch to a new Premium
      Plan
    </Trans>
  );
};

export const SecondUpgradeSubtitle = withInjectedRootStore(
  SecondUpgradeSubtitleComp,
);
